<template>
  <v-container>
    <v-layout align-center>
      <v-flex xs10>
        <h3 class="primary--text">Pessoas - Aniversariantes</h3>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs12 md4 text-xs-right>
        <v-text-field label="Pesquisar" v-model="filtro" color="secondary" append-icon="search"></v-text-field>
      </v-flex>
      <v-flex xs1 text-xs-right>
        <v-tooltip color="secondary" bottom>
          <v-btn slot="activator" dark small color="secondary" @click="go('CadastroPessoa')" depressed>
            <v-icon>add</v-icon>
          </v-btn>
          <span>Adicionar uma nova pessoa</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-layout justify-space-around row wrap>
      <v-flex xs12>
        <v-card class="default-border" flat>
          <v-flex xs10>
            <span class="primary--text">Quantidade total de pessoas: {{ listaModelo.length }}</span>
          </v-flex>
          <v-data-table :headers="headers" :items="listaModelo" class="elevation-1" :search="filtro"
            :pagination.sync="pagination">
            <template v-slot:items="props">
              <td>{{ props.item.nome }}</td>
              <td>
                {{
                    customFormatComputed.toLocaleDateString(props.item.dataNascimento)
                }}
              </td>
              <td>{{ props.item.email ? props.item.email : "vazio" }}</td>
              <td>{{ props.item.whatapp ? props.item.whatapp : "vazio" }}</td>
              <td>{{ props.item.usuario.nome }}</td>
              <td>
                {{
                    customFormatComputed.toLocaleDateTimeString(
                      props.item.dataIncluso
                    )
                }}
              </td>
              <td class="text-xs-center">
                <v-icon @click="goEdit(cipherComputed.encrypt(props.item.idPessoa))">edit</v-icon>
                <v-icon @click="
                  verPessoa(cipherComputed.encrypt(props.item.idPessoa))
                ">open_in_new</v-icon>
                <v-icon @click="linkWhatsapp(props.item.nome, props.item.whatapp)"
                  :disabled="props.item.whatapp == null">fab fa-whatsapp</v-icon>
                <v-icon @click="agendar(props.item)">event</v-icon>
                <v-icon @click="
                  goPagamento(cipherComputed.encrypt(props.item.idPessoa))
                ">attach_money</v-icon>
                <v-icon @click="
                  verDocumentos(cipherComputed.encrypt(props.item.idPessoa))
                ">system_update_alt</v-icon>
                <v-icon @click="deletaPessoa(props.item.idPessoa)" :disabled="
                  usuarioLogado.idtipousuario != perfilUsr.ID.administrador
                ">delete</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" max-width="900px" @mousedown="close()">
          <v-card>
            <v-card-title class="pt-0">
              <span class="headline pb-0">Agendar Compromiso para
                {{ modeloPessoa === null ? "n/d" : modeloPessoa.nome }}</span>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">Fechar</v-btn>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-form v-model="formularioCadastroValido" ref="formularioCadastroRef">
                <v-container grid-list-md class="pa-0">
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 md12>
                        <v-text-field v-model="modeloAgenda.titulo" color="secondary" prepend-icon="chrome_reader_mode"
                          label="Titulo" :rules="regras.branco50" riquired></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4>
                        <v-menu ref="menuCalendarDataAgenda" :close-on-content-click="false"
                          v-model="menuCalendarDataAgenda" :nudge-right="40" lazy transition="scale-transition" offset-y
                          full-width min-width="290px" :return-value.sync="modeloAgenda.data">
                          <v-text-field slot="activator" v-model="dataAgendaFormatada" label="Data" prepend-icon="event"
                            readonly></v-text-field>
                          <v-date-picker ref="picker" v-model="modeloAgenda.data" locale="pt-br" :rules="regras.branco"
                            required @input="
                              $refs.menuCalendarDataAgenda.save(
                                modeloAgenda.data
                              )
                            "></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs12 md4>
                        <v-dialog ref="dialog" v-model="modalHora" :return-value.sync="modeloAgenda.hora" persistent
                          lazy full-width width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="modeloAgenda.hora" label="Hora" prepend-icon="access_time" readonly
                              v-on="on"></v-text-field>
                          </template>
                          <v-time-picker v-if="modalHora" v-model="modeloAgenda.hora" full-width :landscape="false"
                            format="24hr" min="07:30" max="19:00" riquired :rules="regras.branco">
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="modalHora = false">Cancel</v-btn>
                            <v-btn flat color="primary" @click="$refs.dialog.save(modeloAgenda.hora)">OK</v-btn>
                          </v-time-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs12 md4>
                        <v-text-field v-model="modeloAgenda.duracao" color="secondary" prepend-icon="chrome_reader_mode"
                          label="Duração em min." type="number" :rules="regras.branco" riquired></v-text-field>
                      </v-flex>
                      <v-flex xs12 md8>
                        <v-select v-model="modeloAgenda.usuarioResponsavel" color="secondary" :items="listaUsuarios"
                          :rules="regras.branco" item-text="nome" prepend-icon="business_center"
                          label="Usuário Responsável" return-object riquired></v-select>
                      </v-flex>
                      <v-flex xs12 md4>
                        <v-switch :label="`${modeloAgenda.ativo ? 'Ativo' : 'Inativo'}`" v-model="modeloAgenda.ativo"
                          color="primary"></v-switch>
                      </v-flex>
                      <v-flex xs12 md12>
                        <v-textarea v-model="modeloAgenda.texto" color="secondary" label="Descrição" type="text">
                        </v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn id="fechar" color="primary" class="grey--text text--darken-1" @click="close" flat>Voltar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn id="finalizar" color="primary" class="default-border" depressed
                      :disabled="disableBtnFinalizar || !formValid" @click="finalizar">Finalizar</v-btn>
                  </v-card-actions>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <v-snackbar :timeout="3200" :color="`${snackbarModel.sucesso ? 'success' : 'error'}`"
      v-model="snackbarModel.mostrar" bottom multi-line>
      {{ snackbarModel.text }}
      <v-btn dark flat @click.native="snackbarModel.mostrar = false">Fechar</v-btn>
    </v-snackbar>
  </v-container>
</template>


<script>
import cipher from "@/helpers/cipher.js";
import customFormat from "@/helpers/custom-format.js";
import jwt from "@/helpers/jwt";
import usuarioHelper from "@/helpers/usuario.js";
import perfil from "@/helpers/perfil.js";

export default {
  name: "PessoasAniversariantes",
  data: () => ({
    formularioCadastroValido: false,
    disableBtnFinalizar: false,
    menuCalendarDataAgenda: false,
    dataAgendaFormatada: null,
    modalHora: false,
    dialog: false,
    filtro: "",
    pagination: { sortBy: "dataNascimento", descending: false, rowsPerPage: 20 },
    headers: [
      { text: "Nome", value: "nome" },
      { text: "Data de Nascimento", value: "dataNascimento" },
      { text: "Email", value: "email" },
      { text: "WhatsApp", value: "whatapp" },
      { text: "Usuário criador", value: "usuario.nome" },
      { text: "Data Incluso", value: "dataIncluso" },
      { text: "Ações", value: "", sortable: false, align: "center" },
    ],
    modelo: {
      idPessoa: null,
      dataNascimento: null,
      email: null,
      nome: null,
      whatapp: null,
      usuario: null,
      dataIncluso: null,
    },
    modeloPessoa: null,
    modeloAgenda: {
      pessoa: { idPessoa: null },
      tipoCompromisso: { idTipoCompromisso: 1 },
      data: null,
      hora: null,
      duracao: 30,
      titulo: "",
      texto: null,
      usuarioCriador: {
        idUsuario: jwt.decryptToken().id,
      },
      usuarioResponsavel: null,
      conta: {
        idConta: jwt.decryptToken().idconta,
      },
      ativo: true,
    },
    listaModelo: [],
    listaUsuarios: [],
    snackbarModel: {
      mostrar: false,
      text: "",
      sucesso: false,
    },
    regras: {
      branco: [(v) => !!v || "Você não pode deixar este campo em branco"],
      branco50: [
        (v) => !!v || "Você não pode deixar este campo em branco",
        (v) =>
          v.length < 50 ||
          "O campo deve ter 50 caracteres no maximo ou mais caracteres",
      ],
    },
  }),
  mounted: function () {
    this.buscarDados();
    this.buscarUsuario();
    this.externalSnackbarMessage();
  },
  computed: {
    perfilUsr: function () {
      return perfil;
    },
    usuarioLogado: function () {
      return usuarioHelper.USUARIO_LOGADO();
    },
    customFormatComputed: function () {
      return customFormat;
    },
    cipherComputed: function () {
      return cipher;
    },
    formValid: function () {
      return this.formularioCadastroValido;
    },
  },
  watch: {
    dialog(val) {
      const self = this;
      if (!val) {
        self.close();
      }
    },
    "modeloAgenda.data": function (val) {
      this.dataAgendaFormatada = val
        ? new Date(val).toLocaleDateString("pt-br", { timeZone: "UTC" })
        : "";
    },
  },
  methods: {
    deletaPessoa: function (id) {
      const self = this;
      if (confirm("A Pessoa vai ser apagada e seus registros !")) {
        self.$http
          .get(`${process.env.URL_API}/pessoa/v1/delete/` + id, {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")),
            },
          })
          .then(function (response) {
            const data = response.data;
            self.buscarDados();
            self.snackbarModel.text = data.mensagem;
            self.snackbarModel.sucesso = true;
            self.snackbarModel.mostrar = true;
            self.disableBtnFinalizar = false;
          });
      }
    },
    verPessoa(id) {
      const self = this;
      self.$router.push({ name: "StatusPessoa", params: { id: id } });
    },
    close() {
      const self = this;
      self.modeloPessoa = null;

      self.modeloAgenda.pessoa.idPessoa = null;
      self.modeloAgenda.data = null;
      self.modeloAgenda.hora = null;
      self.modeloAgenda.duracao = 30;
      self.modeloAgenda.texto = null;
      self.modeloAgenda.usuarioResponsavel = null;
      self.modeloAgenda.titulo = "";

      self.dialog = false;
    },
    buscarUsuario: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(
            `${process.env.URL_API}/usuario/v1/busca/nome/conta/ativas/` +
            jwt.decryptToken().idconta,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            self.listaUsuarios = response.data;
            self.listaUsuarios.sort(self.customFormatComputed.compareNome);
          });
      } else {
        self.go("Login");
      }
    },
    agendar(pessoa) {
      const self = this;
      self.modeloPessoa = pessoa;
      self.modeloAgenda.pessoa.idPessoa = pessoa.idPessoa;

      self.dialog = true;
    },
    buscarDados: function () {
      const self = this;

      self.$http
        .get(
          `${process.env.URL_API}/pessoa/v1/aniversario/busca/conta/` +
          jwt.decryptToken().idconta,
          {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")),
            },
          }
        )
        .then(function (response) {
          self.listaModelo = response.data;
        });

    },
    externalSnackbarMessage: function () {
      const self = this;
      if (self.$route.params.snackbarMostrar) {
        self.snackbarModel.sucesso = self.$route.params.snackbarSucesso;
        self.snackbarModel.text = self.$route.params.snackbarText;
        self.snackbarModel.mostrar = self.$route.params.snackbarMostrar;
      }
    },
    linkWhatsapp: function (nome, telefone) {
      const self = this;
      window.open(
        "https://api.whatsapp.com/send?phone=+55" +
        telefone +
        "&text=Olá%20" +
        nome
      );
    },
    finalizar: function () {
      const self = this;
      self.$store.commit("startLoading");
      if (self.$refs.formularioCadastroRef.validate()) {
        const item = jwt.decryptToken();
        if (item != null) {
          if (!self.$route.params.id) {
            self.$http
              .post(
                `${process.env.URL_API}/agenda/v1/cadastro`,
                self.modeloAgenda,
                {
                  headers: {
                    Authorization:
                      "Bearer " + JSON.parse(localStorage.getItem("token")),
                  },
                }
              )
              .then(function (response) {
                const data = response.data;
                if (data.sucesso) {
                  self.disableBtnFinalizar = data.sucesso;
                  self.close();
                  self.go("Pessoas", {
                    snackbarText: data.mensagem,
                    snackbarMostrar: true,
                    snackbarSucesso: data.sucesso,
                  });
                } else {
                  self.snackbarModel.text = data.mensagem;
                  self.snackbarModel.mostrar = true;
                  self.snackbarModel.sucesso = data.sucesso;
                  self.disableBtnFinalizar = data.sucesso;
                }
              })
              .catch(function (error) {
                self.snackbarModel.text = error.response.data.message;
                self.snackbarModel.sucesso = false;
                self.snackbarModel.mostrar = true;
                self.disableBtnFinalizar = false;
              });
          }
        } else {
          self.go("Login");
        }
      }
      self.$store.commit("endLoading");
    },
    goEdit: function (id) {
      const self = this;
      self.$router.push({ name: "CadastroPessoa", params: { id: id } });
    },
    verDocumentos(id) {
      const self = this;
      self.$router.push({ name: "DocumentosPessoa", params: { id: id } });
    },
    goPagamento(id) {
      const self = this;
      self.$router.push({ name: "Caixa", params: { id: id } });
    },
    go: function (routeName, routeParams) {
      const self = this;
      if (this.$router.currentRoute.name != routeName) {
        if (!routeParams) {
          self.$router.push({ name: routeName });
        } else {
          self.$router.push({ name: routeName, params: routeParams });
        }
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/clientes/PessoasAniversariantes.vue